import { Component, OnInit } from '@angular/core';
import { StoreService } from 'src/app/services/store.service';
import { ActivatedRoute, Router } from '@angular/router';
import { first } from 'rxjs/operators';
import { ConfirmationDialogService } from 'src/app/components/confirmation-dialog/confirmation-dialog.service';
import { ToastrService } from 'ngx-toastr';
import { Subject } from 'rxjs';
import { EarningRulesService } from 'src/app/services/earning-rules.service';

@Component({
  selector: 'app-list-tipos-regras',
  templateUrl: './list-tipos-regras.component.html',
  styleUrls: ['./list-tipos-regras.component.css']
})
export class ListTiposRegrasComponent implements OnInit {

  eventsSubject: Subject<any> = new Subject<any>();


  displayedColumns: string[] = ['name','typeRules', 'description', 'status', 'actions'];
  columnsToDisplay = [{field: 'name', header: 'Nome', type: 'text'}, {field: 'description', header: 'Descrição', type: 'text'}, {field: 'typeRules', header: 'Identificador', type: 'text'}];
  columnsObject = [];
    columnsBadge = [{field: 'status', header: 'Estado', type: 'select', selectFieldsDados:  [ {name: 'Ativo', val: 'ACTIVE'}, {name: 'Inativo', val: 'INACTIVE'}]}];
    options = {edit: true, view: true, delete: true, statusUpdate: true};
  title = 'Tipo de Regras';
  novo = {link: '/tipos-regras/criar', nome: 'Novo Tipo Regra'};
  page: any = {base: null, name: null};
  service;

  constructor(private storeService: StoreService,
    private route: ActivatedRoute,
    private earningRulesService: EarningRulesService,
    private confirmationDialogService: ConfirmationDialogService,
    private toast: ToastrService,
    private router: Router,) {
this.service = this.earningRulesService.getAllTypes;
}

ngOnInit(): void {
  this.page.base = this.route.data['value'].base;
  this.page.name = this.route.data['value'].routeName;
  }

  edit = (args: any): void => {
    console.log(args);
    this.router.navigate([this.page.base  + '/editar'], { queryParams: { id: args.id } });
    }
    view = (args: any): void => {
      console.log(args);
      this.router.navigate([this.page.base  + '/view'], { queryParams: { id: args.id } });
    }
    changeStatus = (args: any): void => {
    let textConfirm = '';
    let status = '';
    let textShow = '';

    let service;
    if (args.status === 'ACTIVE'){
      service = this.earningRulesService.inactiveType(args.id);
      textConfirm = 'Pretende Desactivar o tipo Regra ' + args.name + '? Ao desactivar o tipo Regra o estado do tipo de Regra será alterado para INATIVO e não aparecerá nos formulários.';
      status = 'INACTIVE';
      textShow = 'TIPO DE REGRA DESATIVADO COM SUCESSO';
    }
    else{
      service = this.earningRulesService.activeType(args.id);
      textConfirm = 'Pretende Activar o tipo de Regra ' + args.name + '? Ao activar o tipo de Regra o estado da Regra será alterado para ATIVO e aparecerá nos formulários';
      status = 'ACTIVE';
      textShow = 'TIPO DE REGRA ACTIVADO COM SUCESSO';
    }

    this.confirmationDialogService.confirm('Por favor confirme', textConfirm)
    .then((confirmed) =>
    {
      if (confirmed){
        service.subscribe((event: any) => {
          this.toast.warning(textShow, 'Mudança de Estado');
          args.status = status;
      });
      }
    }
    )
    .catch(() => console.log('User dismissed the dialog (e.g., by using ESC, clicking the cross icon, or clicking outside the dialog)'));
  }

    delete = (total: any, args: any, index: number): void => {
      this.confirmationDialogService.confirm('Por favor confirme', 'Pretende apagar este Tipo de Regra ' + args.name + '? Ao eliminar os dados do Tipo de Regra serão perdidos!!')
      .then((confirmed) =>
      {
        if (confirmed){
          const indexo = total.indexOf(args);
          this.earningRulesService.deleteType(args.id).pipe(first())
      .subscribe(
          data => {
            this.toast.warning('Eliminado com sucesso', 'Delete');
            total.splice(indexo, 1);
            console.log('total', total);
            this.eventsSubject.next(total);
          },
          error => {
              console.log('error', error);
          });
        }
      }
      )
      .catch(() => console.log('User dismissed the dialog (e.g., by using ESC, clicking the cross icon, or clicking outside the dialog)'));
      console.log(args);
    }

  }
